var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "#6179EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9754 4.09961L8.90381 4.3428V11.3991L8.9754 11.4705L12.2508 9.53439L8.9754 4.09961Z",
    fill: "#BFCAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9754 4.09961L5.69995 9.53439L8.9754 11.4705V8.04557V4.09961Z",
    fill: "#FFFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97541 12.0913L8.93506 12.1406V14.6541L8.97541 14.7719L12.2528 10.1562L8.97541 12.0913Z",
    fill: "#C0CAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9754 14.7719V12.0913L5.69995 10.1562L8.9754 14.7719Z",
    fill: "#FFFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97534 11.4698L12.2507 9.53373L8.97534 8.04492V11.4698Z",
    fill: "#7F93EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69995 9.53373L8.9754 11.4698V8.04492L5.69995 9.53373Z",
    fill: "#BFCAF9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEth);
export default __webpack_public_path__ + "static/media/Ethereum (ETH).531fa8fb2ed0253868d79f1384d26baa.svg";
export { ForwardRef as ReactComponent };